<template>
  <div class="school">
    <header class="school-title">今日应用人次学校Top5</header>
    <div class="school-progress" v-for="item in school" :key="item.name">
      <p class="mb">
        <span class="fz" :class="{'school-color': item.name < 4}">{{item.name}} </span>
        <span class="lc">**市**第**中学</span>
      </p>
      <el-progress :show-text="false" :percentage="item.percentage"></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      school: [
        { name: 1, percentage: 70 },
        { name: 2, percentage: 60 },
        { name: 3, percentage: 50 },
        { name: 4, percentage: 40 },
        { name: 5, percentage: 30 },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .school {
    box-sizing: border-box;
    width: 100%;
    height: 386px;
    padding: 20px;
    color: #f5f5f5;
    background: url('../../images/exhibition-school-top.png') no-repeat center / 100%;
    &-title {
      line-height: 24px;
      font-size: 20px;
      text-indent: 32px;
      margin-bottom: 20px;
      background: url('../../images/exhibition-icon.png') no-repeat left top / 24px;
    }
    &-color {
      color: #FCE204;
      font-size: 20px;
    }
    &-progress {
      padding-top: 15px;
      height: 45px;
    }
    .el-progress{
      width:100%;
      /deep/ {
        .el-progress__text{
          color: #fff;
          font-size: 14px;
        }
        .el-progress-bar__outer{
          height: 6px!important;
          border: 1px solid #122880;
          background-color: #122880 !important;
        }

        /* 渐变进度条 */
        .el-bg-inner-running .el-progress-bar__inner{
          background-color: unset;
          background-image: linear-gradient(to right, #3587d8 , #6855ff);
        }
        .el-bg-inner-error .el-progress-bar__inner{
          background-image: linear-gradient(to right, #3587d8 , #fb3a7e);
        }
        .el-bg-inner-done .el-progress-bar__inner{
          background-image: linear-gradient(to right, #3587d8 , #53ff54);
        }
      }
    }
    .mb {
      margin-bottom: 10px;
    }
    .fz {
      font-size: 20px;
    }
    .lc {
      letter-spacing: 3px;
      margin-left: 3px;
    }
  }
</style>
